<script setup lang="ts">
// Rota-fantasma: nunca chega a renderizar. O `middleware/promocode.global`
// intercepta /promocode antes e manda pra home com `?open=promocode`, que é o
// que sobe o modal — a rota vive só pra os links antigos continuarem existindo
// (o middleware casa por NOME de rota, então apagar este arquivo faria /promocode
// virar 404 em vez de abrir o modal).
</script>

<template>
  <div />
</template>
